import { css } from '@compiled/react';

import CTAPrimary, { PatternCTAMobileProps } from '@/patterns/wpl/cta-primary/src';

const ctaSectionBaseStyle = css({
	// TODO: font sizes here are smaller than WPL, aligning with Magnolia for now, will continue discussions with designers on long term solution
	'> .cta-primary h2': {
		fontSize: '1.5rem',
		'@media only screen and (min-width: 768px)': {
			fontSize: '2.25rem',
		},
	},
});

export const PaidCtaPrimary = (props: PatternCTAMobileProps) => {
	return (
		<div css={[ctaSectionBaseStyle]}>
			<CTAPrimary
				className="cta-primary"
				backgroundProperties={{
					/* this is deprecated, but need it temporarily to override current behavior */
					textColor: 'n0',
				}}
				{...props}
			/>
		</div>
	);
};
